import React from 'react'
import { Typography } from 'atoms/Typography'
import { cn } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import translate from 'core/translate'
import styles from './deviceSettings__ipTv.jcss'
import { Radio } from 'atoms/Radio'

export const IpTvUseGroups = (p_: {
    useChannelGroups: boolean
    onChange: (value: boolean) => void
    enabled: boolean
}) => {
    return p_.enabled ? (
        <>
            <Typography className={cn(grid.mb_md, styles.title)} type="title">
                {translate('ipTvViewType')}
            </Typography>
            <div>
                <div className={styles.radioButtons}>
                    <Radio
                        label={translate('allChannels')}
                        selected={!p_.useChannelGroups}
                        className={grid.mr_md}
                        onClick={() => p_.onChange(false)}
                    />
                    <Radio
                        label={translate('groupChannels')}
                        selected={p_.useChannelGroups}
                        onClick={() => p_.onChange(true)}
                    />
                </div>
            </div>
        </>
    ) : null
}
